<template>
  <v-card raised>
    <v-card-title class="display-1">
      Locations on shelf

      <v-spacer></v-spacer>

      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search">
      </v-text-field>
    </v-card-title>

    <v-data-table
      :loading="loading"
      :items="locations"
      :headers="headers"
      :footer-props="{'items-per-page-options': [15, 30, 50, 100]}"
      :search="search"
      :options="pagination"
      mobile-breakpoint="0"
    >
      <template v-slot:item="{ item }">
        <tr>
        <td>
          {{ item.name || '-' }}
        </td>
        <td>{{ item.address || '-' }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import productService from '@/services/slotting/product'
  import paginationMixin from '@/mixins/pagination'

  export default {
    name: 'product-locations',

    mixins: [
      paginationMixin
    ],

    data () {
      return {
        loading: false,

        headers: [
          { text: 'Location Name', value: 'name', align: 'left' },
          { text: 'Address', value: 'address', align: 'left' }
        ],

        search: null,

        locations: []
      }
    },

    created () {
      this.loading = true

      productService.getLocations(this.$route.params.id)
        .then(({ data }) => {
          this.locations = data.data
        })
        .finally(() => {
          this.loading = false
        })
    },

    methods: {
      click (location) {
        this.$router.push({
          name: 'Location',
          params: {
            'id': location.id,
            'name': location.name
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Slotting/Products/Locations.vue